export const RENT_HOUSE = {
  nickname: 'PRODUCTS.RENT_HOUSE.nickname',
  icon:'rent-house'
};
